import { authenticatedFetch } from './auth.service';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://admin.goridesrw.com/api/remote';

const handleResponse = async (response, fallbackMessage) => {
  if (!response.ok) {
    let errorMessage = fallbackMessage;
    try {
      const data = await response.json();
      if (data?.message) {
        errorMessage = data.message;
      }
    } catch (error) {
      // ignore parsing issues
    }
    throw new Error(errorMessage);
  }

  return response.json();
};

export const chatService = {
  getConversation: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/chat/conversation`);
    return handleResponse(response, 'Failed to load conversation.');
  },

  getMessages: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/chat/messages`);
    return handleResponse(response, 'Failed to load chat messages.');
  },

  sendMessage: async ({ content, file }) => {
    const formData = new FormData();
    if (content?.trim()) {
      formData.append('content', content.trim());
    }
    if (file) {
      formData.append('file', file);
    }

    const response = await authenticatedFetch(`${BASE_URL}/chat/messages`, {
      method: 'POST',
      body: formData
    });

    return handleResponse(response, 'Failed to send message.');
  },

  markRead: async () => {
    const response = await authenticatedFetch(`${BASE_URL}/chat/read`, {
      method: 'POST'
    });
    return handleResponse(response, 'Failed to update chat status.');
  },

  getAttachmentBlobUrl: async (messageId) => {
    const response = await authenticatedFetch(`${BASE_URL}/chat/messages/attachment?messageId=${messageId}`);
    if (!response.ok) {
      throw new Error('Failed to load attachment preview.');
    }

    const blob = await response.blob();
    return window.URL.createObjectURL(blob);
  },

  downloadAttachment: async (messageId, filename) => {
    const response = await authenticatedFetch(`${BASE_URL}/chat/messages/attachment?messageId=${messageId}`);
    if (!response.ok) {
      throw new Error('Failed to download attachment.');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'attachment';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};
